import { CraClient } from './CraClient';
import HttpClient from '../../gateway/HttpClient';
import HttpMethod from '../../constant/HttpMethod';
import { CraMethods } from '../../constant/MethodNames';
import { query } from '@trlogic/client-js';
import { CraType } from '../../constant/Constants';
import Query = query.Query;
import {
  CraSegmentType,
  CraDateSegmentsSchema,
  CraNumberSegmentsSchema,
  CraStringSegmentsSchema,
  CraVariableSchema,
  PolicyJsonModel,
} from '../../domain/cra/CraDomains';

class NestCraClient implements CraClient {
  private readonly httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  public async save(policy: PolicyJsonModel): Promise<void> {
    const dto = { id: policy.assessor, object: policy };
    return this.httpClient.execute(HttpMethod.POST, CraMethods.SAVE, dto);
  }

  public async delete(id: string, assessor: CraType): Promise<void> {
    return this.httpClient.execute(HttpMethod.DELETE, `${CraMethods.REMOVE}/${id}`, { assessor });
  }

  public async deploy(id: string): Promise<void> {
    return this.httpClient.execute(HttpMethod.POST, `${CraMethods.DEPLOY}/${id}`);
  }

  public async undeploy(id: string): Promise<void> {
    return this.httpClient.execute(HttpMethod.POST, `${CraMethods.UNDEPLOY}/${id}`);
  }

  public async isExist(id: string): Promise<boolean> {
    return this.httpClient.execute(HttpMethod.POST, `${CraMethods.EXIST}/${id}`);
  }

  public async getCount(query: Query): Promise<number> {
    return this.httpClient.execute(HttpMethod.POST, CraMethods.COUNT, query);
  }

  public getPermittedStores(): Promise<Record<string, PolicyJsonModel[]>> {
    return this.httpClient.execute(HttpMethod.GET, CraMethods.GET_PERMITTED_STORES);
  }

  public async variable(object: CraVariableSchema): Promise<void> {
    return this.httpClient.execute(HttpMethod.POST, CraMethods.SAVE_VARIABLE, { object });
  }

  public async variableEnable(id: string, assessor: CraType): Promise<void> {
    return this.httpClient.execute(HttpMethod.PUT, `${CraMethods.CHANGE_VARIABLE_ENABLE}/${id}`, { assessor });
  }

  public async existVariable(name: string, assessor: CraType): Promise<boolean> {
    return this.httpClient.execute(HttpMethod.GET, `${CraMethods.EXIST_VARIABLE}/${assessor}/${name}`);
  }

  public async segment(object: CraStringSegmentsSchema | CraNumberSegmentsSchema | CraDateSegmentsSchema, assessor: CraSegmentType): Promise<void> {
    return this.httpClient.execute(HttpMethod.POST, CraMethods.SEGMENT, { object, assessor });
  }

  public async deleteSegment(id: string, assessor: CraSegmentType): Promise<void> {
    return this.httpClient.execute(HttpMethod.DELETE, `${CraMethods.DELETE_SEGMENT}/${assessor}/${id}`);
  }

  public async getSegmentByVariableName(variableName: string, assessor: CraSegmentType): Promise<any> {
    return this.httpClient.execute(HttpMethod.GET, `${CraMethods.GET_SEGMENT_BY_VARIABLE_NAME}/${assessor}/${variableName}`);
  }

  public async getAssessmentResults(assessor: CraType, query: Query): Promise<any[]> {
    return this.httpClient.execute(HttpMethod.POST, `${CraMethods.GET_ASSESSMENT_RESULTS}/${assessor}/query`, query);
  }

  public async getAssessmentResultById(assessor: CraType, id: string): Promise<any | undefined> {
    return this.httpClient.execute(HttpMethod.GET, `${CraMethods.GET_ASSESSMENT_RESULT_BY_ID}/${assessor}/${id}`);
  }

  public async countAssessmentResults(assessor: CraType, query: Query): Promise<number> {
    return this.httpClient.execute(HttpMethod.POST, `${CraMethods.COUNT_ASSESSMENT_RESULTS}/${assessor}/count`, query);
  }
}

export default NestCraClient;
